// 본체는 components/common/MournerCountLeadModal 로 이관됐다 (요양병원→시설 모달과 폼이 같아 공용화).
// 기존 import 경로 유지용 re-export.
export { default } from "@/components/common/MournerCountLeadModal";
export type { MournerCountLeadModalCopy } from "@/components/common/MournerCountLeadModal";
